import * as Sentry from "@sentry/react";

const dsn =
  "https://b8b301f5a2754f339dc15da681bca609@jjdgqvm81zsux.bugsink.com/1";

export function initBugsink() {
  Sentry.init({
    dsn,
    release: `miniapp@${process.env.REACT_APP_VERSION || "0.1.0"}`,
    integrations: [],
    tracesSampleRate: 0,
  });
}

export { Sentry };
